export default __webpack_public_path__ + "static/media/compleo_horizontal_azul.fc08ad04.svg";